import styled from "styled-components";
// import { theme } from '../../../theme'
import { MdFavoriteBorder, MdCreate } from "react-icons/md";

const Item = styled.div`
  height: 22.564rem;
  border-radius: 8px 6px 0px 0px;
  display: flex;
  flex-direction: column;

  .top {
      width: 100%;
      height: 19.251rem;
      margin: 0;

      .subject-image {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
  }

  .bottom {
    width: 100%;
    // background-color: black;
    // height: 34.04px;
    background-color: #FFFFFF;
    padding: 0 1.1rem;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 0px 0px 6px 6px;
    display:flex;
    flex-direction: row;
    justify-content:space-between;
    align-items:center;
    flex: 1;

    .subject-title {
        font-weight: 700;
        font-size: 1.4rem;
        color: #3B3B42;
        white-space: nowrap; 
        width: 12rem; 
        overflow: hidden;
        text-overflow: ellipsis; 
    }

    .icon {
        cursor: pointer;
        display: flex;
        color: #D6D7D8;
    }
}
`

const LibrarySubjectsItem = ({ subject, imgUrl }) => {
    const isTeacher = window.location.pathname.includes('teacher')
    return (
        <Item>
            <div className="top">
                <img className="subject-image" src={imgUrl} alt={subject} />
            </div>
            <div className="bottom">
                <span className="subject-title">{subject}</span>
                <span className="icon">{isTeacher ? <MdCreate /> : <MdFavoriteBorder />}</span>
            </div>
        </Item>
    )
}

export default LibrarySubjectsItem
